import moment from "moment";
import { defineComponent } from "vue";

import { SmokingStatuses } from "../../../../../../enums/enums";
import { formatDateInput } from "../../../../../../common/vue-helpers/modifiers/value-modifier";
import { enumToMap } from "../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { PalHealthHistory } from "../../../../../../resources-vue/vue-models/palliative-convert-to-pending";

import DatePicker from "../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";

export default defineComponent({
    components: {
        DatePicker
    },

    props: {
        patientHealthHistory: {
            type: PalHealthHistory,
            default: null
        }
    },
    data(vm) {
        return {
            formatDateInput,
            enumToMap,
            smokingStatusEnum: SmokingStatuses
        };
    },

    computed: {
        startDatePickerOptions(): DatepickerOptions {
            let baseDatePickerOptions = {
                autoclose: true,
                endDate: moment().format("MM/DD/YYYY")
            };
            if (this.patientHealthHistory?.smokingEndDate) {
                return Object.assign(baseDatePickerOptions, {
                    endDate: moment(this.patientHealthHistory.smokingEndDate).format("MM/DD/YYYY")
                });
            }
            return baseDatePickerOptions;
        },

        endDatePickerOptions(): DatepickerOptions {
            let baseDatePickerOptions = {
                autoclose: true,
                endDate: moment().format("MM/DD/YYYY")
            };
            if (this.patientHealthHistory?.smokingStartDate) {
                return Object.assign(baseDatePickerOptions, {
                    startDate: moment(this.patientHealthHistory.smokingStartDate).format("MM/DD/YYYY"),
                    endDate: moment().format("MM/DD/YYYY")
                });
            }
            return baseDatePickerOptions;
        },

        historicalStartDatePickerOptions(): DatepickerOptions {
            let baseDatePickerOptions = {
                autoclose: true,
                endDate: moment().format("MM/DD/YYYY")
            };
            if (this.patientHealthHistory?.historicalSmokingStartDate) {
                return Object.assign(baseDatePickerOptions, {
                    endDate: moment(this.patientHealthHistory.historicalSmokingEndDate).format("MM/DD/YYYY")
                });
            }
            return baseDatePickerOptions;
        },

        historicalEndDatePickerOptions(): DatepickerOptions {
            let baseDatePickerOptions = {
                autoclose: true,
                endDate: moment().format("MM/DD/YYYY")
            };
            if (this.patientHealthHistory?.historicalSmokingStartDate) {
                return Object.assign(baseDatePickerOptions, {
                    startDate: moment(this.patientHealthHistory.historicalSmokingStartDate).format("MM/DD/YYYY"),
                    endDate: moment().format("MM/DD/YYYY")
                });
            }
            return baseDatePickerOptions;
        },

        canHideSmokingDate(): boolean {
            if (this.patientHealthHistory.smokingStatus === 0) {
                return true;
            }

            return (
                this.smokingStatusEnum.enum.NeverSmoker == this.patientHealthHistory.smokingStatus ||
                this.smokingStatusEnum.enum.UnknownIfEverSmoked == this.patientHealthHistory.smokingStatus
            );
        },

        canHideHistoricalSmokingDate(): boolean {
            if (this.patientHealthHistory.historicalSmokingStatus === 0) {
                return true;
            }
            return (
                this.smokingStatusEnum.enum.NeverSmoker == this.patientHealthHistory.historicalSmokingStatus ||
                this.smokingStatusEnum.enum.UnknownIfEverSmoked == this.patientHealthHistory.historicalSmokingStatus
            );
        }
    },

    methods: {
        handleDateChange(date: string, name: string) {
            if (name === "smokingStartDate") {
                this.patientHealthHistory.smokingStartDate = date;
            }
            if (name === "smokingEndDate") {
                this.patientHealthHistory.smokingEndDate = date;
            }

            if (name === "historicalSmokingStartDate") {
                this.patientHealthHistory.historicalSmokingStartDate = date;
            }
            if (name === "historicalSmokingEndDate") {
                this.patientHealthHistory.historicalSmokingEndDate = date;
            }
        },

        handleDateInputChange(e: any) {
            const name = e.target.name;
            const value = e.target.value;
            if (name === "smokingStartDate") {
                this.patientHealthHistory.smokingStartDate = value;
            }
            if (name === "smokingEndDate") {
                this.patientHealthHistory.smokingEndDate = value;
            }
            if (name === "historicalSmokingStartDate") {
                this.patientHealthHistory.historicalSmokingStartDate = value;
            }
            if (name === "historicalSmokingEndDate") {
                this.patientHealthHistory.historicalSmokingEndDate = value;
            }
        }
    }
});
